module.exports = __webpack_public_path__ + "img/input_2.7a7a3bb4.png";